// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fetchWrapper, postWrapper } from 'helpers/api'

export const fetchPathProfile = (terrCaseId, query) => (
  fetchWrapper(`/oh-loss/terr-case-path-profile/${terrCaseId}${query}`)
)

export const postPathProfile = (terrCaseId, body) => (
  postWrapper(`/oh-loss/terr-case-path-profile/${terrCaseId}/update-profile-data`, body)
)

export const postStandaloneCaseReport = (query) => (
  postWrapper(`/case-details-reports/custom-case-details-reports/export${query}`)

)

export const postTropoCaseReport = (terrCaseId, query) => (
  postWrapper(`/case-details-reports/${terrCaseId}/oh-loss-case-details${query}`)
)

export const postTropoOhLossReport = (terrCaseId, pathProfilePoints) => (
  postWrapper(`/oh-loss/oh-loss-report/${terrCaseId}`, pathProfilePoints)
)

export const postTropoKMLReport = (terrCaseId, pathProfilePoints) => (
  postWrapper(`/case-details-reports/${terrCaseId}/oh-loss-kml`, pathProfilePoints)
)

export const postTropoEsChk = (body) => (
  postWrapper('/tropo-services/path-profile-with-profile-for-eschk', body)
)

export const postESTropoCaseReport = (earthStationInterferenceCaseId, query) => (
  postWrapper(`/earth-station-interference-cases/${earthStationInterferenceCaseId}/case-details-report-with-oh-loss-data${query}`)
)

export const postESTropoOhLossReport = (earthStationInterferenceCaseId, pathProfilePoints) => (
  postWrapper(`/earth-station-interference-cases/${earthStationInterferenceCaseId}/oh-loss/export`, pathProfilePoints)
)

export const postESTropoKMLReport = (earthStationInterferenceCaseId, pathProfilePoints) => (
  postWrapper(`/earth-station-interference-cases/${earthStationInterferenceCaseId}/oh-loss-kml/export`, pathProfilePoints)
)
